import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BorderlessButton } from "../../components/BorderlessButton";
import { useOpenPromotion } from "../link-store";

export function EditPromotionButton({ promotionID, placementID }) {
    const [_, __, setOpenPromotion] = useOpenPromotion();
    // HACK
    const navigate = useNavigate();
    return (
        <BorderlessButton
            style={{ fontSize: "1em" }}
            //onClick={() => setOpenPromotion(promotionID, placementID)}
            onClick={()=>navigate(`../../../settings/${promotionID}`)}
        >
            <FaEdit style={{ marginLeft: "0.125em" }} title="Edit Link" />
        </BorderlessButton>
    );
}
